<p class="desc">{{ description }}</p>
<app-dynamic-form-landing [formSections]="formSections" [showButtons]="false" [valuesToPatch]="formValues"
  (closeCalenderEvent)="onIsClose($event)" (fieldValueChanged)="onFieldValueChanged()"></app-dynamic-form-landing>
<div class="btn_container" [ngStyle]="{'margin-bottom': '24px'}">
  <button class="btn btn-secondary-outline btn-lg fetch_gst" (click)="onFetchGst()">Fetch GST</button>
  <button class="btn btn-danger-outline btn-lg fetch_gst" (click)="onRemoveGst()">Remove GST</button>
</div>
<div class="btn_container">
  <button class="btn btn-danger-outline btn-lg" (click)="onClearGST()">Clear</button>
  <button class="btn btn-danger-outline btn-lg" (click)="onCancel()">Cancel</button>
  <button class="btn btn-primary btn-lg" (click)="onSubmit()" [appProgressButton]="false" [buttonText]="'Save'"
    [disabled]="!enableButton">
    Save
  </button>
</div>